"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CircleWithCheck;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function CircleWithCheck() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "65",
    viewBox: "0 0 64 65",
    fill: "none"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2198 25.11C50.5998 24.97 51.0398 25.16 51.1798 25.5499L51.1898 25.56C52.0298 27.84 52.4598 30.2299 52.4598 32.68C52.4598 43.97 43.2798 53.16 31.9898 53.16C20.6998 53.16 11.5098 43.97 11.5098 32.68C11.5098 21.3899 20.6998 12.2 31.9898 12.2C35.8798 12.2 39.6598 13.29 42.9298 15.36C43.2798 15.59 43.3798 16.05 43.1598 16.4C42.9298 16.75 42.4698 16.85 42.1198 16.63C39.0898 14.71 35.5798 13.7 31.9798 13.7C21.5198 13.7 13.0098 22.1999 13.0098 32.6699C13.0098 43.1399 21.5298 51.65 31.9898 51.65C42.4498 51.65 50.9598 43.1299 50.9598 32.6699C50.9598 30.3999 50.5598 28.18 49.7798 26.07C49.6298 25.69 49.8298 25.25 50.2198 25.11ZM24.7598 32.07C25.0998 31.84 25.5698 31.93 25.7998 32.27V32.26L33.6798 43.9L49.9498 15.56C50.1498 15.2 50.6098 15.07 50.9698 15.28C51.3298 15.48 51.4598 15.94 51.2498 16.3L34.3798 45.6899C34.2498 45.9199 34.0198 46.07 33.7598 46.07H33.7298C33.4798 46.07 33.2498 45.95 33.1098 45.74L24.5598 33.11C24.3298 32.77 24.4198 32.2999 24.7598 32.07Z",
    fill: "#004DB2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.2304 15.3501C44.2304 17.1701 42.7604 18.6401 40.9404 18.6401C39.1204 18.6401 37.6504 17.1701 37.6504 15.3501C37.6504 13.5301 39.1204 12.0601 40.9404 12.0601C42.7604 12.0601 44.2304 13.5301 44.2304 15.3501Z",
    fill: "#4DC7EB"
  }));
}